import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import { getReviewsStatic, reviewDispute, reviewReply } from "helpers/backend_helper";

export const getReviewStaticThunk = createAsyncThunk(
  "review/getReviewStatic", async () => {
    try {
      const response = await getReviewsStatic();
      const data = response.data;
      return data;
    } catch (error) {
      return error;
    }
  });

  export const replyReviewCreate = createAsyncThunk(
    "review/reply",
    async ({
      id,
      reply
    }: {
      id: string;
      reply: string;
    }) => {
      try {
        const info = {
          id,
          reply,
        };
  
        const response = await reviewReply(info);
        return  response;
      } catch (error) {
        throw error;
      }
    }
  );

  export const disputeReview = createAsyncThunk("dispute/review",async ({id,reason}: {
      id: string;
      reason: string;
    }) => {
      try {
        const response = await reviewDispute(id, reason);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  );
  